import React from 'react';
import type { BillingAmount, SubscriptionStatus } from '../types';
interface PriceDisplayProps {
  amount: BillingAmount;
  status?: SubscriptionStatus;
}
const getCurrencySymbol = (currency: string) => {
  switch (currency) {
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
    case 'AUD':
      return 'A$';
    default:
      return '$';
  }
};
export const PriceDisplay = ({
  amount,
  status
}: PriceDisplayProps) => {
  const hasDiscount = amount.original !== amount.current;
  const showDiscount = hasDiscount && !['inactive', 'not_subscribed', 'incomplete_payment'].includes(status || '');
  const currencySymbol = getCurrencySymbol(amount.currency);
  // For EUR, the symbol goes after the number with a space
  const formatPrice = (price: number) => {
    if (amount.currency === 'EUR') {
      return `${price} ${currencySymbol}`;
    }
    return `${currencySymbol}${price}`;
  };
  return <div className="flex items-center gap-2" data-id="element-94">
      {showDiscount && <span className="text-gray-500 line-through text-sm" data-id="element-95">
          {formatPrice(amount.original)}/month
        </span>}
      <span className={`font-medium ${showDiscount ? 'text-[#00CAB7]' : ''}`} data-id="element-96">
        {formatPrice(amount.current)}/month
      </span>
    </div>;
};